<template lang="pug">
  b-modal.receive-documents-form-modal(
    ref="modal"
    title="Recepción de Documentos SII"
    v-bind="$attrs"
    @show="onReset"
    @ok="onSubmit"
    :ok-disabled="loading"
    :cancel-disabled="loading"
    :ok-title="loading ? '🔄 Procesando...' : 'Iniciar Proceso'")
    b-form
      b-form-group(label="Email de Notificación")
        VueTagsInput(
          v-model="contactTagValue"
          placeholder="Correos de Contacto"
          :tags="contactTags"
          :validation="contactTagValidations"
          @tags-changed="newTags => { contactTags = newTags; contactTagValue = '' }"
        )
        .errors(v-if="$v.$dirty")
          b-form-invalid-feedback(:state="$v.form.email.required") Campo requerido

      //- // Información del cliente
      //- b-row.mt-3
      //-   b-col(md="6")
      //-     b-form-group(label="Cliente")
      //-       b-form-input(
      //-         v-model="clientInfo.name"
      //-         disabled
      //-         :state="null"
      //-       )
      //-   b-col(md="6")
      //-     b-form-group(label="RUT")
      //-       b-form-input(
      //-         v-model="clientInfo.rut"
      //-         disabled
      //-         :state="null"
      //-       )
      
      //- // Opciones de ejecución
      //- b-form-group(label="Opciones de Ejecución")
      //-   b-form-checkbox(
      //-     v-model="form.showProcess"
      //-   ) Ver proceso en tiempo real (modo interfaz)
      //-   small.text-muted Si está marcado, se abrirá el navegador para que puedas ver el proceso de scraping paso a paso
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import { mapActions } from 'vuex'
import { emailValidator } from '../../shared/validations'
import VueTagsInput from '@johmun/vue-tags-input'

export default {
  inheritAttrs: false,
  components: {
    VueTagsInput
  },
  data () {
    return {
      contactTags: [],
      contactTagValue: '',
      contactTagValidations: [
        {
          classes: 'avoid-item',
          rule: ({ text }) => !emailValidator(text)
        }
      ],
      loading: false,
      defaultEmail: '',
      businessId: null,
      clientInfo: {
        name: '',
        rut: ''
      },
      form: {
        showProcess: false
      }
    }
  },
  validations: {
    form: {
      email: { required }
    }
  },
  methods: {
    ...mapActions(['receiveDocuments']),
    
    showModal (options) {
      this.defaultEmail = options.defaultEmail || ''
      this.businessId = options.businessId || null
      this.clientInfo.name = options.businessName || ''
      this.clientInfo.rut = options.businessRut || ''
      this.contactTags = options.defaultEmail ? options.defaultEmail.split(',').map(e => { return { text: e } }) : []
      this.$refs.modal.show()
    },
    
    onReset () {
      this.$v.$reset()
      this.form = {
        email: this.defaultEmail,
        showProcess: false
      }
      this.contactTagValue = ''
      this.loading = false
    },
    
    async onSubmit (e) {
      if(this.$v.$invalid) {
        this.$v.$touch()
        e.preventDefault()
      } else {
        // Activar estado de loading
        this.loading = true
        
        const data = {
          clientId: this.businessId,
          emails: this.form.email.split(','),
          headless: !this.form.showProcess, // Si showProcess es true, headless debe ser false
          sendNotification: true
        }
        
        console.log('🚀 Enviando datos al endpoint:', data)
        
        // Mostrar toast de inicio del proceso
        this.$root.$bvToast.toast(
          'Iniciando proceso de recepción de documentos del SII...', 
          {
            title: 'Proceso iniciado',
            variant: 'info',
            autoHideDelay: 4000
          }
        )
        
        const response = await this.receiveDocuments({ data })
        const status = response.status
        
        console.log('📨 Respuesta del servidor:', response)
        
        // Usar el toast que viene del servidor si está disponible, sino usar la lógica anterior
        if (response.data && response.data.toast) {
          this.$root.$bvToast.toast(response.data.toast.message, {
            title: response.data.toast.title,
            variant: response.data.toast.variant,
            autoHideDelay: 5000
          })
        } else {
          // Fallback a la lógica anterior si no hay toast en la respuesta
          const message = response.data ? response.data.message : 'Error en la comunicación con el servidor'
          this.$root.$bvToast.toast(message, {
            title: status >= 200 && status < 300 ? 'Éxito!!' : 'Oops!!',
            variant: status >= 200 && status < 300 ? 'success' : 'danger',
            autoHideDelay: 5000
          })
        }
      }
      // Desactivar estado de loading al final
      this.loading = false
    }
  },
  watch: {
    /**
     * Actualiza los email de contacto separados por "," cada vez que cambian los tags de contacto
     */
    contactTags () {
      this.form.email = this.contactTags.map(e => e.text.trim()).join(',')
    }
  }
}
</script>

<style scoped>
.receive-documents-form-modal .modal-body {
  max-height: 80vh;
  overflow-y: auto;
}
</style>
